import React from "react";
import { FiZap } from "react-icons/fi";
import { nextLessonNumber, typePositionFor, lessonWithNumber } from "../utils/lessonNumbering";

// Number input for Add/Edit Lesson. Suggests the next free number, shows the
// lesson's position within its type (e.g. "Basics #4") and warns on duplicates.
function LessonNumberField({ value, onChange, lessons, lessonsLoaded, type, selfId, inputStyle, accent = "#2a9d8f" }) {
    const others = lessons.filter((l) => l.id !== selfId);
    const autoValue = nextLessonNumber(others);
    const isAuto = String(value) === String(autoValue);
    const typePos = value !== "" ? typePositionFor(lessons, type, value, selfId) : null;
    const conflict = lessonWithNumber(lessons, value, selfId);

    return (
        <div>
            <div style={{ display: "flex", gap: 6 }}>
                <input
                    type="number"
                    min="1"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    style={{ ...inputStyle, flex: 1, minWidth: 0 }}
                    onFocus={(e) => (e.target.style.borderColor = accent)}
                    onBlur={(e) => (e.target.style.borderColor = "#E0E0E0")}
                />
                <button
                    type="button"
                    onClick={() => onChange(String(autoValue))}
                    disabled={!lessonsLoaded || isAuto}
                    title={`Use next available number (${autoValue})`}
                    style={{
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        padding: "0 10px",
                        borderRadius: 10,
                        border: `1.5px solid ${accent}`,
                        borderBottomWidth: 3,
                        background: isAuto ? `${accent}18` : "#fff",
                        color: accent,
                        fontWeight: 700,
                        fontSize: 12,
                        fontFamily: "'Quicksand', sans-serif",
                        cursor: !lessonsLoaded || isAuto ? "default" : "pointer",
                        opacity: lessonsLoaded ? 1 : 0.5,
                    }}
                >
                    <FiZap size={12} /> Auto
                </button>
            </div>
            <div style={{ fontSize: 11, color: "#888", marginTop: 5, lineHeight: 1.4 }}>
                {!lessonsLoaded ? (
                    "Loading lesson order…"
                ) : (
                    <>
                        {isAuto ? `Next available (${others.length} other lessons)` : `Next available: ${autoValue}`}
                        {typePos != null && (
                            <>
                                {" · "}
                                <strong style={{ color: accent }}>{type} #{typePos}</strong>
                            </>
                        )}
                    </>
                )}
            </div>
            {conflict && (
                <div style={{ fontSize: 11, color: "#c0392b", marginTop: 3, fontWeight: 600 }}>
                    #{value} is already used by “{conflict.title || "Untitled"}”
                </div>
            )}
        </div>
    );
}

export default LessonNumberField;
